module.exports = "/images/arrow-icon.svg?c2132398b3dd531b898262aad121a316";